import "./testing";
import "./testing/fr";
import "./optimization";
import "./prep";
import "./products";
import "./program-modules";
import "./programs";
import "./procedures";
import "./moon-articles";
import "./moon-articles.fr";
import "./moon-articles-guides";
import "./moon-articles-guides.fr";
import "./moon-articles-donor";
import "./moon-articles-decisions";
import "./moon-articles-decisions.fr";
import "./moon-articles-science";
import "./moon-articles-science.fr";
import "./moon-articles-costs";
import "./moon-articles-costs.fr";
import "./moon-articles-country-guides";
import "./moon-articles-travel";
import "./moon-articles-travel.fr";
import "./new-articles-batch1";
import "./new-articles-batch1.fr";
import "./new-articles-batch2";
import "./new-articles-batch2.fr";
import "./new-articles-batch3";
import "./new-articles-batch4";
import "./new-articles-batch4.fr";
// appointments removed — content migrated to procedures and testing
import "./medications";
import "./conditions";
import "./conditions/fr";
